import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { group } from 'console';
import AuthService from '../../auth/Authorization.service';
import { UserService } from '../../sdk';
import { Usuarios } from '../../sdk/@types/Usuarios';

type PA<T> = PayloadAction<T>;

interface AuthState {
  user: Usuarios.UsuarioDetalhadoGrupo | null;
  fetching: boolean;
}

const initialState: AuthState = {
  user: null,
  fetching: false,
};

export const fetchUser = createAsyncThunk(
  'auth/fetchUser',
  async (userId: number, { rejectWithValue, dispatch }) => {
    try {
      const user = await UserService.getUsuarioDetalhado(userId);

      const grupos = await UserService.getGrupoUsuario(userId);
      console.log(await UserService.getRestaurantes(userId));
      const restaurantes = await UserService.getRestaurantes(userId);
      console.log('wfaafadsfaas');
      if (grupos._embedded.grupos[0].id == 5) {
        const restaurantes: any = {
          _embedded: {
            restaurantes: [],
          },
        };
      }

      console.log('restaurantes');
      console.log(restaurantes);

      /*grupos._embedded.grupos.map((grup) => {
        if (grup.nome === 'Vendedor') {
          window.alert('Você não tem acesso a este sistema!');
          AuthService.imperativelySendToLogout();
          return;
        }
      });*/

      const usuarioCompleto = {
        usuario: user,
        grupos: grupos,
        restaurantes: restaurantes,
      };

      console.log(usuarioCompleto);

      dispatch(storeUser(usuarioCompleto));
    } catch (err) {
      return rejectWithValue({ ...(err as object) });
    }
  }
);

const authSlice = createSlice({
  initialState,
  name: 'auth',
  reducers: {
    storeUser(state, action: PA<Usuarios.UsuarioDetalhadoGrupo>) {
      state.user = action.payload;
    },
    clearUser(state) {
      state.user = null;
    },
    updateUser(state, action: PA<Usuarios.UsuarioDetalhadoGrupo>) {
      state.user = action.payload;
    },
  },
});

export const { storeUser, clearUser, updateUser } = authSlice.actions;

const authReducer = authSlice.reducer;
export default authReducer;
